
<div class="container">
  <div style="font-size: 22px;margin-top: 56px;margin-right: auto;text-align: center">Votre paiement a été enregistré et votre accréditation envoyer par mail <i class="fa fa-check"></i></div>

  <div style="font-weight: bold;margin-top: 10px;text-align: center">
    <a   title="Poursuivre" href="javascript:void(0);" (click)="Retour()" id="validateCmd1" class="inline-block text-uppercase col-md-3">
      Retour inscriptions
    </a>
  </div>
</div>
